import _ from 'lodash';
import { Button } from '@m/alchemy-ui/Button';

import * as Styled from './ToggleOptions.styled';

function OptionList<TValue>({
  value,
  disabled,
  options,
  onChange,
}: OptionListProps<TValue>) {
  return (
    <div>
      <Styled.NoWrapButtonGroup isJoined>
        {options.map(option => {
          const isPressed = _.isEqual(option.value, value);
          const handleClick = () => onChange(option.value);

          return (
            <Button
              key={option.id}
              disabled={disabled}
              onClick={handleClick}
              aria-pressed={isPressed}
              priority={isPressed ? 'primary' : 'secondary'}
            >
              {option.text}
            </Button>
          );
        })}
      </Styled.NoWrapButtonGroup>
    </div>
  );
}

interface OptionListProps<TValue> {
  disabled: boolean;
  options: ToggleOptionsOption<TValue>[];
  onChange: (value: TValue) => void;
  value?: TValue;
}

export function ToggleOptions<TValue>({
  value,
  title,
  description,
  options,
  disabled = false,
  onChange = () => {},
}: ToggleOptionsProps<TValue>) {
  const handleChange = (newValue: TValue) => {
    if (newValue === value) return;
    onChange(newValue);
  };

  return (
    <section>
      <Styled.Title>{title}</Styled.Title>
      <Styled.DescriptionButtonContainer>
        {description && <Styled.Description>{description}</Styled.Description>}

        {options && (
          <OptionList
            disabled={disabled}
            value={value}
            options={options}
            onChange={handleChange}
          />
        )}
      </Styled.DescriptionButtonContainer>
    </section>
  );
}

interface ToggleOptionsOption<TValue> {
  id: string;
  text: string;
  value: TValue;
}

interface ToggleOptionsProps<TValue> {
  title: string;
  value?: TValue;
  onChange?: (newValue: TValue) => void;
  description?: string;
  options?: ToggleOptionsOption<TValue>[];
  disabled?: boolean;
}
